export const formatPrice = (price: number, withDevice = true) =>
  `${price.toFixed(2).replace('.', ',')}${withDevice ? '€' : ''}`;
